import React from "react";



const UnavailableToken = () => {


  return (
    <div className="text-center h-[100vh] flex">
      <div className="p-8  bg-white text-center max-w-[400px] inline-flex flex-col items-center m-auto shadow-lg rounded-md m-auto">
        <img src="/images/info-icon.svg" />
        <div className="">
          <div className=" text-black text-5xl font-semibold mt-8">Geçersiz Ödeme Bağlantısı</div>
          <div className="text-zinc-800 text-lg mt-3 font-normal">Lütfen yetkili ile iletişime geçiniz.</div>
        </div>
      </div>
    </div>
  );
}
export default UnavailableToken;